import { useDates } from "../../../dates/DatesContext";
import useDSPSellerInfo from "./useDSPSellerInfo";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { DatasetsQueryFilter } from "../../../zodios/apiDefinitions/api/dsp/common";

export const useDSPLineItemDatasetsQuery = (
  dimensions = "line_item_id",
  includeMetadata = true,
  filters: DatasetsQueryFilter[] = [],
) => {
  const { start, end, preStart, preEnd, group } = useDates();
  const { dspAdvertiser } = useDSPSellerInfo();

  const startDate = start.format("YYYY-MM-DD");
  const endDate = end.format("YYYY-MM-DD");
  const preStartDate = preStart.format("YYYY-MM-DD");
  const preEndDate = preEnd.format("YYYY-MM-DD");

  const isGroupedByDate = dimensions.includes("start_date");

  let formattedDimensions = dimensions;
  let formattedFilters: DatasetsQueryFilter[] = [
    { id: "date", value: { op: "gte", value: startDate } },
    { id: "date", value: { op: "lte", value: endDate } },
    { id: "dsp_seller_info_id", value: { op: "eq", value: dspAdvertiser?.id } },
    { id: "date_prev", value: { op: "gte", value: preStartDate } },
    { id: "date_prev", value: { op: "lte", value: preEndDate } },
    ...filters,
  ];

  if (isGroupedByDate) {
    formattedFilters = formattedFilters.filter((filter) => filter.id !== "date_prev");
    formattedDimensions = formattedDimensions.replace("start_date", group);
  }

  const body = {
    model: "dsplineitem" as const,
    dimensions: formattedDimensions,
    entity_mode: includeMetadata ? ("all" as const) : ("none" as const),
    filters: formattedFilters,
  };

  return useQuery({
    queryKey: ["dspLineItemDatasets", dimensions, includeMetadata, formattedFilters],
    enabled: !!dspAdvertiser?.id,
    queryFn: async () => {
      return await apiClient.dspLineItemDatasetsQuery(body);
    },
  });
};
